export default __webpack_public_path__ + "static/media/icon4.4e908c2f.svg";